  <div class="col-md-10 m-3">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group pb-0 mb-1">
          <label for="">เลือกคอนโดที่จะคงไว้ (ตัวหลัก )</label>
          <select class="form-control" [(ngModel)]="fromCdid">          
            <option *ngFor="let item of rowData" [value]="item.cdid">{{item.cdid}} - {{item.cdname}}</option>
          </select>
          <label for="">ค้นหา</label>
          <input type="text" class="form-control" [(ngModel)]="gridSearch" (keyup)="onQuickFilterChanged()" />
        </div>
      </div>
    </div>
    <div class="row">
      <ag-grid-angular style="width:100%;height:300px;" class="ag-theme-balham" [rowData]="rowData"
        [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" (rowClicked)="onRowlicked($event)">
      </ag-grid-angular>
    </div>
  </div>


  <div class="col-lg-12 col-md-12 p-al-0">
    <h4>{{cd_name}}</h4>
    <div style="height:40vh;">
      <ag-grid-angular style="width:100%;height:100%;overflow: 'hidden';" id="myGrid" class="ag-theme-balham"
        [gridOptions]="gridOptions"
        [columnDefs]="colCondoRoom" [rowData]="CondoRoomList" (gridReady)="onGridReady3($event)" (rowClicked)="onRowRoomClicked($event)" 
        [rowSelection]="rowSelection"
        [defaultColDef]="defaultColDef">
      </ag-grid-angular>
    </div>
  </div>
  <ng2-toasty></ng2-toasty>